// extracted by mini-css-extract-plugin
export default {"container":"qi-z","backNav":"ri-z"};